import React from 'react';
const Card = ({ children, className = "" }) => {
  return (
    <div className={`card shadow-lg rounded mt-8 ${className}`}>
      {children}
    </div>
  );
};

const CardHeader = ({ children, className = "" }) => {
  return (
    <div className={`card-header ${className}`}>
      {children}
    </div>
  );
};

const CardTitle = ({ children, className = "" }) => {
  return <h2 className={`card-title ${className}`}>{children}</h2>;
};

const CardContent = ({ children, className = "" }) => {
  return <div className={`card-body ${className}`}>{children}</div>;
};

const WirelessAccessPoints = () => {
  const accessPoints = [
    {
      model: 'AP310',
      bands: ['2.4 GHz'],
      channels2_4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      channels5: []
    },
    {
      model: 'AP360',
      bands: ['2.4 GHz'],
      channels2_4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      channels5: []
    },
    {
      model: 'AP1210AC',
      bands: ['2.4 GHz', '5 GHz'],
      channels2_4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      channels5: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144, 149, 153, 157, 161, 165]
    },
    {
      model: 'AP1250AC-MAX',
      bands: ['2.4 GHz', '5 GHz'],
      channels2_4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      channels5: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144, 149, 153, 157, 161, 165]
    },
    {
      model: 'AP1250AC-OUT',
      bands: ['2.4 GHz', '5 GHz'],
      channels2_4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      channels5: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144, 149, 153, 157, 161, 165]
    },
    {
      model: 'AP1350AC',
      bands: ['2.4 GHz', '5 GHz'],
      channels2_4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      channels5: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144, 149, 153, 157, 161, 165]
    },
    {
      model: 'AP1350AC-S',
      bands: ['2.4 GHz', '5 GHz'],
      channels2_4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      channels5: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144, 149, 153, 157, 161, 165]
    },
    {
      model: 'AP1750AC',
      bands: ['2.4 GHz', '5 GHz'],
      channels2_4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      channels5: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144, 149, 153, 157, 161, 165]
    },
    {
      model: 'AP1800AX',
      bands: ['2.4 GHz', '5 GHz'],
      channels2_4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      channels5: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144, 149, 153, 157, 161, 165]
    },
    {
      model: 'AP3000AX',
      bands: ['2.4 GHz', '5 GHz'],
      channels2_4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      channels5: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144, 149, 153, 157, 161, 165]
    },
    {
      model: 'AP3000AX-OUT',
      bands: ['2.4 GHz', '5 GHz'],
      channels2_4: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      channels5: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144, 149, 153, 157, 161, 165]
    }
  ];

  return (
    <Card className="w-full max-w-6xl mx-auto">
      {/* <CardHeader>
        <CardTitle>Canais suportados</CardTitle>
      </CardHeader> */}
      <CardContent>
        <div className="overflow-x-auto max-w-full">
          <div className="overflow-x-auto overflow-y-auto max-h-[70vh] w-full">
            <table className="w-full border-collapse min-w-[600px]">
              <thead className="sticky top-0 z-10">
                <tr>
                  <th className="p-2 border bg-green-100 text-left sticky top-0 bg-opacity-100 z-20">PRODUTO</th>
                  <th className="p-2 border bg-green-100 text-left sticky top-0 bg-opacity-100 z-20">BANDA</th>
                  <th className="p-2 border bg-green-100 text-left sticky top-0 bg-opacity-100 z-20">CANAIS SUPORTADOS</th>
                </tr>
              </thead>
              <tbody>
                {accessPoints.map((ap) => (
                  <React.Fragment key={ap.model}>
                    {ap.bands.map((band, index) => (
                      <tr key={`${ap.model}-${band}`}>
                        {index === 0 && (
                          <td
                            rowSpan={ap.bands.length}
                            className="p-2 border font-medium align-top"
                          >
                            {ap.model}
                          </td>
                        )}
                        <td className="p-2 border">{band}</td>
                        <td className="p-2 border">
                          {band === '2.4 GHz'
                            ? ap.channels2_4.join(', ')
                            : ap.channels5.join(', ')}
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default WirelessAccessPoints;